import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * WordPress dependencies
 */
import { Path, SVG, TextControl, Popover, Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { insertObject, useAnchorRef } from '@wordpress/rich-text';
import { MediaUpload, RichTextToolbarButton, MediaUploadCheck } from '@wordpress/block-editor';
import { keyboardReturn } from '@wordpress/icons';
var ALLOWED_MEDIA_TYPES = ['image'];
var name = 'core/image';

var title = __('Inline image');

export var image = {
  name: name,
  title: title,
  keywords: [__('photo'), __('media')],
  object: true,
  tagName: 'img',
  className: null,
  attributes: {
    className: 'class',
    style: 'style',
    url: 'src',
    alt: 'alt'
  },
  edit: Edit
};

function InlineUI(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      activeObjectAttributes = _ref.activeObjectAttributes,
      contentRef = _ref.contentRef;
  var style = activeObjectAttributes.style;

  var _useState = useState(style.replace(/\D/g, '')),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var anchorRef = useAnchorRef({
    ref: contentRef,
    value: value,
    settings: image
  });
  return createElement(Popover, {
    position: "bottom center",
    focusOnMount: false,
    anchorRef: anchorRef
  }, createElement("form", {
    className: "block-editor-format-toolbar__image-container-content",
    onSubmit: function onSubmit(event) {
      var newReplacements = value.replacements.slice();
      newReplacements[value.start] = {
        type: name,
        attributes: _objectSpread(_objectSpread({}, activeObjectAttributes), {}, {
          style: "width: ".concat(width, "px;")
        })
      };
      onChange(_objectSpread(_objectSpread({}, value), {}, {
        replacements: newReplacements
      }));
      event.preventDefault();
    }
  }, createElement(TextControl, {
    className: "block-editor-format-toolbar__image-container-value",
    type: "number",
    label: __('Width'),
    value: width,
    min: 1,
    onChange: function onChange(newWidth) {
      return setWidth(newWidth);
    }
  }), createElement(Button, {
    icon: keyboardReturn,
    label: __('Apply'),
    type: "submit"
  })));
}

function Edit(_ref2) {
  var value = _ref2.value,
      onChange = _ref2.onChange,
      onFocus = _ref2.onFocus,
      isObjectActive = _ref2.isObjectActive,
      activeObjectAttributes = _ref2.activeObjectAttributes,
      contentRef = _ref2.contentRef;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isModalOpen = _useState4[0],
      setIsModalOpen = _useState4[1];

  function openModal() {
    setIsModalOpen(true);
  }

  function closeModal() {
    setIsModalOpen(false);
  }

  return createElement(MediaUploadCheck, null, createElement(RichTextToolbarButton, {
    icon: createElement(SVG, {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, createElement(Path, {
      d: "M4 18.5h16V17H4v1.5zM16 13v1.5h4V13h-4zM5.1 15h7.8c.6 0 1.1-.5 1.1-1.1V6.1c0-.6-.5-1.1-1.1-1.1H5.1C4.5 5 4 5.5 4 6.1v7.8c0 .6.5 1.1 1.1 1.1zm.4-8.5h7V10l-1-1c-.3-.3-.8-.3-1 0l-1.6 1.5-1.2-.7c-.3-.2-.6-.2-.9 0l-1.3 1V6.5zm0 6.1l1.8-1.3 1.3.8c.3.2.7.2.9-.1l1.5-1.4 1.5 1.4v1.5h-7v-.9z"
    })),
    title: title,
    onClick: openModal,
    isActive: isObjectActive
  }), isModalOpen && createElement(MediaUpload, {
    allowedTypes: ALLOWED_MEDIA_TYPES,
    onSelect: function onSelect(_ref3) {
      var id = _ref3.id,
          url = _ref3.url,
          alt = _ref3.alt,
          imgWidth = _ref3.width;
      closeModal();
      onChange(insertObject(value, {
        type: name,
        attributes: {
          className: "wp-image-".concat(id),
          style: "width: ".concat(Math.min(imgWidth, 150), "px;"),
          url: url,
          alt: alt
        }
      }));
      onFocus();
    },
    onClose: closeModal,
    render: function render(_ref4) {
      var open = _ref4.open;
      open();
      return null;
    }
  }), isObjectActive && createElement(InlineUI, {
    value: value,
    onChange: onChange,
    activeObjectAttributes: activeObjectAttributes,
    contentRef: contentRef
  }));
}
//# sourceMappingURL=index.js.map